export default __webpack_public_path__ + "static/media/tc-fig1.d8a05d9a.svg";